import RestRequestFactory from '@core/utils/network/RestRequestFactory';
import LottoRequest from '@core/services/lotto/_private/LottoRequest';
import IResponse from '@core/utils/types/IResponse';
import ILottoEventDto from '@core/mappers/lotto/dtos/ILottoEventDto';
import ILottoGameDto from '@core/mappers/lotto/dtos/ILottoGameDto';

export default class RestService {
    private readonly request: any;

    constructor(hostServer: string, restRequestFactory = RestRequestFactory) {
        this.request = restRequestFactory.create(hostServer);
    }

    /**
     * @throws {RequestError}
     */
    public getLottoOffer(startDate: Date, endDate: Date, sort?: string): Promise<IResponse<ILottoEventDto[]>> {
        return this.request({
            url: '/offer/getLottoOfferByDate',
            method: 'get',
            params: LottoRequest.createLottoOfferRequest(startDate, endDate, sort)
        });
    }

    /**
     * @throws {RequestError}
     */
    public getLottoDetails(lottoIds: number[]): Promise<IResponse<ILottoEventDto[]>> {
        return this.request({
            url: '/lotto/getLottoById',
            method: 'get',
            params: LottoRequest.createLottoDetailsRequest(lottoIds)
        });
    }

    public getLottoGames(): Promise<IResponse<ILottoGameDto[]>> {
        return this.request({
            url: '/offer/getLotoNames',
            method: 'get'
        });
    }

    public getLottoEventResults(startDate: Date, endDate: Date): Promise<IResponse<ILottoEventDto[]>> {
        return this.request({
            url: '/offer/fetchLottoResults',
            method: 'get',
            params: LottoRequest.createLottoEventResultsRequest(startDate, endDate)
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/lotto/_private/RestService.ts